// extracted by mini-css-extract-plugin
export var dividerContainer = "_6h-0";
export var line = "_6h-1";